module.exports = __webpack_public_path__ + "static/media/Lens-Accent_TW.cb0a3e89.png";